import React, { useState, useEffect } from 'react'
import SewingRepairInBatchTable from './SewingRepairInBatchTable'
import { getListSewingRepairInBatch, exportListSewingRepairInBatch } from '../../../services/api/3dApi'
import { Link } from 'react-router-dom'
import { Icon, Pagination, Select, Button, Spin, message, AutoComplete, Input } from 'antd'
import { getListBrand } from '../../../services/api/3dApi'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import UseDebounce from '../../users/helpers/UseDebounce'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import moment from 'moment'

function SewingRepairInBatchPage() {
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [listSewingRepair, setListSewingRepair] = useState([])
    const [listBrand, setListBrand] = useState([])
    const [brand, setBrand] = useState([])
    const [errorType, setErrorType] = useState('')
    const [type, setType] = useState([])
    const [pendingAt, setPendingdAt] = useState({})
    const [loading, setLoading] = useState(false)

    const debounceError = errorType === '' ? UseDebounce(errorType, 0) : UseDebounce(errorType, 500)

    const fetchSewingRepair = async () => {
        setLoading(true)
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (brand.length) payload.brand_name = brand
            if (!!errorType) payload.type_error = [errorType]
            if (type.length) payload.sku = type
            if (Object.keys(pendingAt).length) {
                payload['sewing_repair_from'] = pendingAt.from
                payload['sewing_repair_to'] = pendingAt.to
            }

            const { data: res } = await getListSewingRepairInBatch(payload)
            const { data, success, message: mess } = { ...res }
            if (success) {
                setListSewingRepair(data.batchitems)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        }
        finally {
            setLoading(false)
        }
    }

    const _getListBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const { data: Data } = await getListBrand(payload)
            const { data, success, message } = Data
            const Brands = data.Brands.map(i => ({ value: i.name, label: i.name }))
            if (success) {
                setListBrand(Brands)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeBrand = (value) => {
        setBrand(value)
        setPage(1)
    }
    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }
    const handleChangePendingAt = (field, value) => {
        setPendingdAt(value)
        setPage(1)
    }
    const handleChangeErrorType = (value) => {
        setErrorType(value)
        setPage(1)
    }

    const exportSewingRepair = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (brand.length) payload.brand_name = brand
            if (!!errorType) payload.type_error = [errorType]
            if (type.length) payload.sku = type
            if (Object.keys(pendingAt).length) {
                payload['sewing_repair_from'] = pendingAt.from
                payload['sewing_repair_to'] = pendingAt.to
            }
            const { data } = await exportListSewingRepairInBatch(payload)

            if (data) {
                downloadFileFromData(data, { filename: `sewing-repair-in-batch-items-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

            setLoading(false)

        } catch (e) {
            setError(e.message)
            setLoading(false)
        }
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    useEffect(() => {
        fetchSewingRepair()
    }, [brand, debounceError, type, pendingAt, limit, page])

    useEffect(() => {
        _getListBrand()
    }, [])

    const { Option } = Select
    const disableNoBrand = !!brand && brand.length > 0 && !brand.includes('no brand')
    const disableOptionBrand = !!brand && brand.length > 0 && brand.includes('no brand')

    const options = [
        'Lỗi đường may',
        'Sai kích thước',
        'Đối xứng chi tiết',
        'Không khớp hình',
        'Lỗi mác',
        'Thiếu, nhầm chi tiết',
        'Thiếu đường may',
        'Bục rách',
        'Lỗi lót',
        'Lỗi chân kim',
        'Lỗi khóa',
        'Lệch họng cổ',
    ]

    return (
        <div className='SewingRepairInBatchPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Thống kê sửa may</h3>
                        <div className='d-flex align-items-center'>
                            <Button
                                className='ant-btn ant-btn-primary ml-3'
                                onClick={exportSewingRepair}
                                disabled={loading}
                            >
                                Export
                            </Button>
                            <Link
                                className='ant-btn ml-3'
                                to='sewing-repair'
                                disabled={loading}
                            >
                                Items cần sửa may
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-4'>
                                <label className='font-weight-bold mb-1'>Loại sản phẩm:</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                />
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <label htmlFor="error_type" className="Error font-weight-bold mb-1">Loại lỗi:</label>
                                <AutoComplete
                                    options={options}
                                    dataSource={options}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleChangeErrorType}
                                    allowClear
                                    placeholder="Search loại lỗi"
                                    className='w-100'
                                >
                                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                                </AutoComplete>
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <label className="font-weight-bold mb-1">Ngày báo lỗi</label>
                                <FilterDateRangeV2
                                    field='pending_at'
                                    onDatesChange={handleChangePendingAt}
                                />
                            </div>
                            <div className='col-12 col-xl-2'>
                                <label for="request_update" className="d-block w-100 font-weight-bold mb-1">Brand</label>
                                <Select
                                    name='brand'
                                    className='brand'
                                    mode={'multiple'}
                                    onChange={(value) => handleChangeBrand(value)}
                                    value={brand}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn brand name'
                                    style={{ width: '100%' }}
                                >
                                    <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                    {listBrand.length && listBrand.map((i, index) => (
                                        <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                    ))
                                    }
                                </Select>
                            </div>
                        </div>

                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <SewingRepairInBatchTable
                            listSewingRepair={listSewingRepair}
                            setType={setType}
                            setBrand={setBrand}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default SewingRepairInBatchPage